import React from 'react';

const fmt = v => (v ?? 0).toLocaleString();
const CARDS = [
  ['cert_courses', 'Cert Courses (incl. Languages)', fmt],
  ['unique_cert_courses', 'Unique Cert Courses', fmt],
  ['enrollments', 'Total Enrollments', fmt],
  ['completions', 'Total Completions', fmt],
  ['vouchers', 'Vouchers Issued', fmt],
  ['completion_rate', 'Completion Rate', v => `${v ?? 0}%`],
  ['vouchers_vs_completions', 'Vouchers Issued vs. Completions %', v => `${v ?? 0}%`],
];

export function CertPrepCards({ cards }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0,1fr))', gap: 10, marginBottom: 20 }}>
      {CARDS.map(([k, label, f]) => (
        <div key={k} className="stat-card" data-testid={`certprep-card-${k}`} style={{ padding: 14 }}>
          <div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#64748b', fontWeight: 600, minHeight: 28 }}>{label}</div>
          <div data-testid={`certprep-card-${k}-value`} style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', marginTop: 4 }}>
            {cards ? f(cards[k]) : '…'}
          </div>
        </div>
      ))}
    </div>
  );
}

export function SnapshotTable({ title, dimLabel, rows, testId }) {
  const total = k => rows.reduce((s, r) => s + (r[k] || 0), 0);
  return (
    <div className="table-container" data-testid={testId} style={{ flex: 1 }}>
      <div style={{ padding: '12px 16px', fontWeight: 700, fontSize: 13 }}>{title}</div>
      <table>
        <thead><tr><th>{dimLabel}</th><th style={{ textAlign: 'right' }}>Enrollments</th><th style={{ textAlign: 'right' }}>Completions</th><th style={{ textAlign: 'right' }}>Vouchers Issued</th></tr></thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.label} data-testid={`${testId}-row-${r.label.replace(/\s+/g, '-').toLowerCase()}`}>
              <td style={{ fontWeight: 600 }}>{r.label}</td>
              {['enrollments', 'completions', 'vouchers'].map(k => <td key={k} style={{ textAlign: 'right' }}>{fmt(r[k])}</td>)}
            </tr>
          ))}
          <tr style={{ background: '#f8fafc', fontWeight: 700 }}>
            <td>Total</td>
            {['enrollments', 'completions', 'vouchers'].map(k => <td key={k} style={{ textAlign: 'right' }}>{fmt(total(k))}</td>)}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
